/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadFileSpec } from './UploadFileSpec';
import {
    UploadFileSpecFromJSON,
    UploadFileSpecFromJSONTyped,
    UploadFileSpecToJSON,
    UploadFileSpecToJSONTyped,
} from './UploadFileSpec';

/**
 * 
 * @export
 * @interface UploadBatchCreateRequest
 */
export interface UploadBatchCreateRequest {
    /**
     * 
     */
    files: Array<UploadFileSpec>;
}

/**
 * Check if a given object implements the UploadBatchCreateRequest interface.
 */
export function instanceOfUploadBatchCreateRequest(value: object): value is UploadBatchCreateRequest {
    if (!('files' in value) || value['files'] === undefined) return false;
    return true;
}

export function UploadBatchCreateRequestFromJSON(json: any): UploadBatchCreateRequest {
    return UploadBatchCreateRequestFromJSONTyped(json, false);
}

export function UploadBatchCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadBatchCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'files': ((json['files'] as Array<any>).map(UploadFileSpecFromJSON)),
    };
}

export function UploadBatchCreateRequestToJSON(json: any): UploadBatchCreateRequest {
    return UploadBatchCreateRequestToJSONTyped(json, false);
}

export function UploadBatchCreateRequestToJSONTyped(value?: UploadBatchCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'files': ((value['files'] as Array<any>).map(UploadFileSpecToJSON)),
    };
}

